import { render, staticRenderFns } from "./ActivitiesLayout.vue?vue&type=template&id=d2f9e98c&scoped=true&"
import script from "./ActivitiesLayout.vue?vue&type=script&lang=js&"
export * from "./ActivitiesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f9e98c",
  null
  
)

export default component.exports